// Navigation: hamburger menu, sticky header, body.scrolled toggle

function openNav() {
	$(".hamburger").addClass("active");
	$(".header").addClass("active");
	$(".mask").addClass("active");
	$("body").addClass("active");
	$(".nav").addClass("expand");
}

function closeNav() {
	$(".hamburger").removeClass("active");
	$(".header").removeClass("active");
	$(".nav").removeClass("expand");
	setTimeout(function () {
		$(".mask").removeClass("active");
		$("body").removeClass("active");
	}, 300);
}

$(".hamburger").click(function () {
	if ($(this).hasClass("active")) {
		closeNav();
	} else {
		openNav();
	}
	return false;
});

// Close nav on mask click
$(".mask").click(function () {
	closeNav();
});

// Close nav on menu link click
$(".nav .menu-link").click(function () {
	closeNav();
});

function isTouchDevice() {
	return (
		true ==
		("ontouchstart" in window ||
			(window.DocumentTouch && document instanceof DocumentTouch))
	);
}

if (isTouchDevice() === true) {
	$(".arrow-plus").click(function () {
		$(this).toggleClass("active");
		$_parent = $(this).parents(".menu-item");
		$_parent.find(".submenu").toggleClass("open");
		return false;
	});
}

// Single scroll handler with rAF throttle
(function () {
	var ticking = false;

	$(window).on("scroll", function () {
		if (!ticking) {
			window.requestAnimationFrame(function () {
				var scrollTop = $(window).scrollTop();

				// Sticky header
				if (scrollTop > 106) {
					$(".header").addClass("header-fixed");
					$(".header .navbar").addClass("fixed");
				} else {
					$(".header").removeClass("header-fixed");
					$(".header .navbar").removeClass("fixed");
				}

				// Body scrolled class (used by multiple pages)
				if (scrollTop > 100) {
					$("body").addClass("scrolled");
				} else {
					$("body").removeClass("scrolled");
				}

				ticking = false;
			});
			ticking = true;
		}
	});
})();
